import {
  BaseApi,
  type ItemResponse,
  type ListResponse,
  type RequestHeaders,
  type RequestParams,
  type SuccessResponse,
} from '@bv/api/base';

export class KnowledgeBaseApi extends BaseApi {
  private overrideHeaders(headers?: RequestHeaders): RequestHeaders {
    return {
      ...(headers || {}),
      service_name: import.meta.env.VITE_CURRENT_SERVICE_UNIQUE_NAME,
    };
  }

  public constructor(public endpoint = 'rag/files') {
    super(endpoint);
  }

  public async create(
    data: Partial<KnowledgeBaseItem> | FormData,
    {
      params,
      headers,
    }: {
      params?: RequestParams;
      headers?: RequestHeaders;
    } = {},
  ): Promise<KnowledgeBaseItem> {
    return this.request<KnowledgeBaseItem, ItemResponse<KnowledgeBaseItem>>({
      method: 'post',
      data,
      params,
      headers: this.overrideHeaders(headers),
    }).then((response) => {
      return response.data;
    });
  }

  public async delete(
    id: string | number,
    {
      params,
      headers,
    }: {
      params?: RequestParams;
      headers?: RequestHeaders;
    } = {},
  ): Promise<SuccessResponse> {
    return this.request<KnowledgeBaseItem, SuccessResponse>({
      method: 'delete',
      url: id.toString(),
      params,
      headers: this.overrideHeaders(headers),
    });
  }

  public async list({
    params,
    headers,
  }: {
    params?: RequestParams;
    headers?: RequestHeaders;
  } = {}): Promise<KnowledgeBaseItem[]> {
    return this.request<KnowledgeBaseItem, ListResponse<KnowledgeBaseItem>>({
      method: 'get',
      params: {
        ...params,
        limit: 100,
      },
      headers: this.overrideHeaders(headers),
    }).then((response) => {
      return response.data;
    });
  }

  public async show(
    id: string | number,
    {
      params,
      headers,
    }: {
      params?: RequestParams;
      headers?: RequestHeaders;
    } = {},
  ): Promise<KnowledgeBaseItem> {
    return this.request<KnowledgeBaseItem, ItemResponse<KnowledgeBaseItem>>({
      method: 'get',
      url: id.toString(),
      params,
      headers: this.overrideHeaders(headers),
    }).then((response) => {
      return response.data;
    });
  }

  public async update(
    id: string | number,
    data: Partial<KnowledgeBaseItem> | FormData,
    {
      params,
      headers,
    }: {
      params?: RequestParams;
      headers?: RequestHeaders;
    } = {},
  ): Promise<KnowledgeBaseItem> {
    return this.request<KnowledgeBaseItem, ItemResponse<KnowledgeBaseItem>>({
      method: 'put',
      url: id.toString(),
      data,
      params,
      headers: this.overrideHeaders(headers),
    }).then((response) => {
      return response.data;
    });
  }
}

export const knowledgeBaseApi = new KnowledgeBaseApi();
